// extracted by mini-css-extract-plugin
module.exports = {"cnt":"OrdersModule_cnt__FUwZk","title":"OrdersModule_title__13lTv","subtitle":"OrdersModule_subtitle__1mbU-"};